import React, { useEffect, useState, useRef } from "react";
import "@widgets/products/filters/filters_gallery.scss";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  HeaderNavigation,
  HeaderPanel,
  SearchFormDefault,
  SearchFormBg,
  HeaderNavigationMobile,
  ModalLogin,
  ModalSignup,
  ModalRecovery,
  CartLimitPopup,
} from "@features";
import {
  CookiesPolicyPopup,
  TechWorksPopup,
  ProductHuntPopup,
  GetFreePopup,
  GetSubscribePopup,
} from "@widgets";
import { BROWSE_URL, ADMIN_URL, ADMIN_PROJECT_CREATE_URL } from "@app/routes";
import {
  HEADER_NAVIGATION_LINKS,
  HEADER_NAVIGATION_LOGO,
  HEADER_NAVIGATION_LOGO_CUT,
} from "./header_full.consts";
import { getProductsTC } from '@entities/products/model/products.actions';
import {
  userGetCartTC,
  userLogoutTC,
  userSetFiltersStatusAC,
  userSetSearchAC,
} from "@entities/user/model/user.actions";
import {
  userGetActiveSearchSC,
  userGetFreeProductPopupSC,
  userGetSubscribePopupSC,
  userGetFiltersStatusSC,
  userGetLimitPopupSC,
  userGetModalLoginShowSC,
  userGetModalRecoveryShowSC,
  userGetModalSignupShowSC,
  userGetCustomerSC,
} from "@entities/user/model/user.selectors";
import { Button } from "@ui-kit";
import { clearAllNode, searchValueToArray } from "@shared";
import { SearchFormContext } from "@shared/hooks";
const ChevronIcon = "/images/icons/chevron-gray500.svg";
const ChevronBlueIcon = "/images/icons/chevron-accent700.svg";

const HeaderFull = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useRef();
  const searchValue = useSelector(userGetActiveSearchSC);
  const isModalLoginShow = useSelector(userGetModalLoginShowSC);
  const isModalSignupShow = useSelector(userGetModalSignupShowSC);
  const isModalRecoveryShow = useSelector(userGetModalRecoveryShowSC);
  const isCartLimitPopupShow = useSelector(userGetLimitPopupSC);
  const isGetFreeProductShow = useSelector(userGetFreeProductPopupSC);
  const isSubscribeShow = useSelector(userGetSubscribePopupSC);
  const statusFilters = useSelector(userGetFiltersStatusSC);
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();
  const user = useSelector(userGetCustomerSC);
  const [isVisibleUpBtn, setIsVisibleUpBtn] = useState(false);

  const IS_BROWSER_PAGE = pathname === BROWSE_URL.pathname;
  const IS_ADMIN_URL = pathname.includes(ADMIN_URL.pathname);
  const IS_TECHWORKS_SHOW =
    localStorage.getItem("accept_tech_works") !== "true";
  const IS_COOKIE_SHOW =
    localStorage.getItem("accept_cookie") !== "true" &&
    sessionStorage.getItem("decline_cookie") !== "true";
  const IS_PRODHUNT_SHOW =
    localStorage.getItem("accept_producthunt") !== "true";
  const FULL_PATH = `${pathname}${search}`;

  //console.log("IS_PRODHUNT_SHOW",IS_PRODHUNT_SHOW, localStorage.getItem("accept_producthunt"));
  //console.log("IS_TECHWORKS_SHOW",IS_TECHWORKS_SHOW, localStorage.getItem("accept_tech_works"));

  if (!IS_ADMIN_URL && !user.id) {
    localStorage.setItem("fullpath", FULL_PATH);
  }

  if (FULL_PATH.includes(ADMIN_PROJECT_CREATE_URL.pathname)) {
    localStorage.removeItem("fullpath");
  }

  useEffect(() => {
    if (!user.id) {
      return;
    }

    dispatch(userGetCartTC(user.basketId));
    // eslint-disable-next-line
  }, [dispatch, user.id]);

  const checkScrollHeight = () => {
    const documentHeight = document.documentElement.scrollHeight;
    const windowWidth = window.innerWidth;
    const scrollY = window.scrollY;
    const SCROLL_VIEW = 600;
    const VIEW_HEIGHT = 2000;
    const MOBILE_HEIGHT = 1000;
    const MOBILE_WIDTH = 800;

    if (scrollY > SCROLL_VIEW) {
      if (
        (documentHeight > VIEW_HEIGHT && windowWidth > MOBILE_WIDTH) ||
        (documentHeight > MOBILE_HEIGHT && windowWidth <= MOBILE_WIDTH)
      ) {
        setIsVisibleUpBtn(true);
      } else {
        setIsVisibleUpBtn(false);
      }
    } else {
      setIsVisibleUpBtn(false);
    }
  };

  useEffect(() => {
    checkScrollHeight();
    window.addEventListener("resize", checkScrollHeight);
    window.addEventListener("scroll", checkScrollHeight);

    return () => {
      window.removeEventListener("resize", checkScrollHeight);
      window.removeEventListener("scroll", checkScrollHeight);
    };
  }, []);

  const moveUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onChangeSearch = (event) => {
    const value = event?.target?.value || "";

    dispatch(userSetSearchAC(value));
  };

  const setFiltersOpen = (value) => {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const SCREEN_WIDTH =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const isMobileScreen = SCREEN_WIDTH < 640;

    const status = { ...statusFilters, isOpen: value };

    if (value && scrollPosition > 360) {
      status["sticky"] = true;
    }

    if (isMobileScreen) {
      const filtersRef = document.querySelector(".title-hide-box");
      filtersRef.scrollIntoView({ behavior: "smooth", block: "nearest" });

      if (value) {
        dispatch(userSetFiltersStatusAC(status));
      }
    } else {
      dispatch(userSetFiltersStatusAC(status));
    }
  };

  const onSubmitSearch = (event) => {
    event.preventDefault();

    const search_value = event?.target?.search?.value || "";
    let searchByString;

    const search = { page: 1, limit: 80 };

    const orderBy = searchParams.get("orderBy");
    if (!orderBy) {
      search.orderBy = "popular";
    }

    if (search_value) {
      const valueWithautSpaces = search_value.replace(/\s\s+/g, " ");
      const multiSearchArray = searchValueToArray(valueWithautSpaces);

      searchByString = multiSearchArray.join(",");
      search.searchBy = searchByString;
    } else {
      searchByString = "";
    }

    dispatch(userSetSearchAC(searchByString));

    clearAllNode("div[data-info-last]");

    const path = {
      pathname: BROWSE_URL.pathname,
      search: new URLSearchParams(search).toString(),
    };

    navigate(path);
    dispatch(getProductsTC(path.search));

    setTimeout(() => {
      document.querySelector("#root").scrollIntoView();
    }, 500);
  };

  const logout = async () => {
    dispatch(userLogoutTC());
  };

  const DefaultHeader = (
    <div className="d-flex jc-sb header__wrapper">
      <SearchFormContext.Provider
        value={{
          onSubmitSearch,
          onChangeSearch,
          searchValue,
        }}
      >
        <HeaderNavigationMobile headerLinks={HEADER_NAVIGATION_LOGO_CUT} />
      </SearchFormContext.Provider>

      <HeaderNavigation headerLinks={HEADER_NAVIGATION_LINKS} />
      {!IS_BROWSER_PAGE && (
        <SearchFormDefault
          onSubmit={onSubmitSearch}
          onChange={onChangeSearch}
          placeholder="Search"
          value={searchValue}
        />
      )}
      <HeaderPanel logout={logout} />
    </div>
  );

  const BrowseScrollHeader = (
    <div className="header__wrapper-scroll">
      <HeaderNavigation
        headerLinks={HEADER_NAVIGATION_LOGO}
        className="mr-16"
      />
      <div className="filters-gallery__button">
        <Button
          className="filters-btn main"
          theme="secondary-gray"
          size="sm"
          iconRight={ChevronIcon}
          onClick={() => setFiltersOpen(!statusFilters?.isOpen)}
        >
          Filters
        </Button>

        {statusFilters?.isSelected && (
          <div className="filters-select__indicator" />
        )}
      </div>
      <SearchFormBg
        onSubmit={onSubmitSearch}
        onChange={onChangeSearch}
        placeholder="Search"
        value={searchValue}
      />
    </div>
  );

  return (
    <>
      {IS_TECHWORKS_SHOW && <TechWorksPopup />}
      {IS_COOKIE_SHOW && <CookiesPolicyPopup />}
      {IS_PRODHUNT_SHOW && <ProductHuntPopup />}
      <header className="header" ref={ref}>
        <div className="full__container">
          {BrowseScrollHeader}
          {DefaultHeader}
        </div>
      </header>
      {isVisibleUpBtn && (
        <Button
          theme="secondary"
          className="move-up__btn"
          iconLeft={ChevronBlueIcon}
          title="Move up"
          onClick={moveUp}
        />
      )}
      {isModalLoginShow && <ModalLogin />}
      {isModalSignupShow && <ModalSignup />}
      {isModalRecoveryShow && <ModalRecovery />}
      {isCartLimitPopupShow && <CartLimitPopup />}
      {isGetFreeProductShow && <GetFreePopup />}
      {isSubscribeShow && <GetSubscribePopup />}
    </>
  );
};

export default HeaderFull;
